import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';
import { useFilteredTodoCards } from '../../../todo-cards/helpers/should-show-todo-card';
import { TodoCard } from '../../../todo-cards/todo-card';
import { todoCardData } from '../../../todo-cards/todo-card-data';

export const AdvancedOptionsStep = () => {
  const advancedOptionsCards = useFilteredTodoCards(todoCardData, {
    advancedOptionsTodo: true,
  });

  return (
    <FlexColumn className={style['advanced-options-step']}>
      <FlexColumn className={style['congratulations-banner']}>
        <FontAwesomeIcon className={style['check-icon']} icon={faCircleCheck} />
        <Text className={style['congratulations-title']} textType={TextType.H2} value={messages.congratulationsTitle} />
        <Text className={style['congratulations-subtitle']} textType={TextType.Paragraph} value={messages.congratulationsSubtitle} />
      </FlexColumn>
      <FlexColumn className={style['header-section']}>
        <Text className={style.header} textType={TextType.H2} value={messages.stepTitle} />
        <Text textType={TextType.Description} value={messages.stepDescription} />
      </FlexColumn>
      <div className={style['todo-cards-section']}>
        <div className={style['cards-grid']}>
          {advancedOptionsCards.map((card) => (
            <TodoCard key={card.id} description={card.description} id={card.id} link={card.link} title={card.title} />
          ))}
        </div>
      </div>
    </FlexColumn>
  );
};
